export { default } from './usePoller';
